import { FirestoreTimestamp } from "../services/dto/FirestoreTimeStamp";
import { StoreDeliveryConfigurations } from "./StoreDeliveryConfiguration";

export enum StoreStatus {
  ENABLED = "enabled",
  DISABLED = "disabled",
  ARCHIVED = "archived",
}

export interface Store {
  id: string;
  name: string;
  address: string;
  phoneNumber: string;
  subdomain: string;
  email: string;
  createdAt?: Date;
  updatedAt?: Date;
  users: string[];
  password: string;
  status?: StoreStatus;
  storeConfig?: StoreConfig;
  packConfig?: StorePackConfig;
  deliveryConfigurations?: StoreDeliveryConfigurations[];
}

export interface StoreConfig {
  facebookPixelId?: string;
  facebookAccessToken?: string;
  logo?: string;
  bannerImage?: string;
  bannerImageMobile?: string;
  language?: StoreLanguage;
  emailForSupport?: string;
  phoneNumberForSupport?: string;
  template?: VTemplate;
  currency?: string;
}

export interface StorePackConfig {
  packId?: string;
  expiredAt?: Date;
  isActive?: boolean;
  isTrial?: boolean;
  permissions?: string[];
}

export enum StoreLanguage {
  EN = "en",
  AR = "ar",
  FR = "fr",
}

export enum VTemplate {
  VALENCIA = "valencia",
  RIO = "rio",
  DAKAR = "dakar",
}
